/**
 * ProductAttribute 模块接口
 * 商品属性相关
 */

import { get } from '../request';

/**
 * 获取运动品类列表
 * GET /product-attributes/sport-categories
 */
export const getSportCategories = () => {
  return get<string[]>('/product-attributes/sport-categories');
};
